import { InfosupCoverSheet } from "../InfosupCover";

// Brochure animée, transposée de la maquette book-animation.html du ticket IS-1621 :
// la couverture se soulève en boucle (animate-book-open) au-dessus d'une première page
// statique dont seul le tiers droit — colonne squelette grise — est dévoilé.
type Props = {
  travelId: number;
  travelTitle: string;
  travelImage: { id: number; realname: string; name: string; caption: string } | null;
  dateStart: string | null;
  dateEnd: string | null;
  countries: Array<{ title: string; alias: string | null }>;
};
export const InfosupBook = (props: Props) => {
  return (
    <div className="transition-[filter] duration-300 [perspective:750px] [perspective-origin:50%_46%] group-hover/book:blur-[2.5px]">
      <div className="relative h-[243px] w-[190px]">
        <div className="absolute inset-y-[4px] left-0 right-[4px] rounded-l-[2px] rounded-r-[4px] border border-[#E8E8E8] bg-white [filter:drop-shadow(2px_3px_14px_rgba(0,0,0,0.2))]">
          <div className="absolute top-[6.5%] right-[4%] bottom-[4%] flex w-[30%] flex-col">
            <div className="mb-[9.5%] h-[9px] w-[78%] rounded-[2px] bg-[#D9D9D9]" />
            <div className="h-[50.5px] w-full bg-[repeating-linear-gradient(to_bottom,#E0E0E0_0,#E0E0E0_2.5px,transparent_2.5px,transparent_4px)]" />
            <div className="mt-[1.5px] h-[2.5px] w-[78%] rounded-[1px] bg-[#E0E0E0]" />
            <div className="h-[12%] shrink-0" />
            <div className="h-[3px] w-[78%] rounded-[1px] bg-[#D9D9D9]" />
            <div className="h-[12%] shrink-0" />
            <div className="h-[22.5px] w-full bg-[repeating-linear-gradient(to_bottom,#E0E0E0_0,#E0E0E0_2.5px,transparent_2.5px,transparent_4px)]" />
            <div className="mt-[1.5px] h-[2.5px] w-[78%] rounded-[1px] bg-[#E0E0E0]" />
            <div className="h-[9%] shrink-0" />
            <div className="h-[2.5px] w-full rounded-[1px] bg-[#E0E0E0]" />
            <div className="mt-[1.5px] h-[2.5px] w-[78%] rounded-[1px] bg-[#E0E0E0]" />
            <div className="absolute right-0 bottom-0 h-[3px] w-[9px] rounded-[1px] bg-[#E0E0E0]" />
          </div>
        </div>
        <div className="absolute inset-0 origin-left transition-transform duration-500 [filter:drop-shadow(0_8px_9px_rgba(0,0,0,0.06))_drop-shadow(0_2px_4px_rgba(0,0,0,0.05))] motion-safe:animate-book-open group-hover/book:animate-none">
          <div className="absolute inset-0 overflow-hidden rounded-l-[2px] rounded-r-[6px] border border-[#E8E8E8] bg-white shadow-[inset_0.5px_0_2px_rgba(0,0,0,0.08),inset_0_-2px_2px_rgba(0,0,0,0.05),inset_0_2.5px_1px_#FFF,2px_2px_7px_rgba(0,0,0,0.12)]">
            <div className="absolute top-0 left-[13.6px] origin-top-left scale-[0.2886]">
              <InfosupCoverSheet {...props} />
            </div>
            <div className="absolute inset-y-0 left-[9px] w-px bg-gradient-to-b from-black/0 via-black/10 to-black/0" />
            <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(0,0,0,0.10)_0%,rgba(0,0,0,0.06)_1%,transparent_3%),linear-gradient(to_right,transparent_2.8%,rgba(0,0,0,0.07)_4.6%,transparent_8%),linear-gradient(to_right,transparent_5%,rgba(255,255,255,0.7)_7%,transparent_11%),linear-gradient(to_bottom,rgba(0,0,0,0.03)_0%,transparent_8%,transparent_92%,rgba(0,0,0,0.04)_100%)]" />
          </div>
        </div>
      </div>
    </div>
  );
};
